import { ReactNode } from 'react';
import { PageHeader } from '../layout/PageHeader';

type Props = { actions: ReactNode };

export function CategoryPageHeader({ actions }: Props) {
    return (
        <PageHeader
            title="Bibliothèque de contenus"
            subtitle="Stocker, gérer et partager vos contenus"
            actions={actions}
        />
    );
}
